import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: 'var(--framer-font-family), sans-serif',
  },
});

export default theme;
